import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared';

import { RouteKeyNumbersComponent } from './route-key-numbers.component';

@NgModule({
    imports: [CommonModule, SharedModule],
    exports: [RouteKeyNumbersComponent],
    declarations: [RouteKeyNumbersComponent]
})
export class RouteKeyNumbersModule {}
